import React, { useRef } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Box } from '@mui/material';

interface ColumnProps {
  field?: string;
  header: string;
  body?: (rowData: any) => React.ReactNode;
  sortable?: boolean;
  filter?: boolean;
  filterPlaceholder?: string;
  style?: React.CSSProperties;
  frozen?: boolean;
}

interface TabelaBaseProps {
  value: any[];
  columns: ColumnProps[];
  dataKey?: string;
  header?: React.ReactNode;
  rows?: number;
  paginator?: boolean;
  exportCSV?: boolean;
  scrollable?: boolean;
  scrollHeight?: string;
  frozenWidth?: string; // largura fixa para colunas frozen, ex: '200px'
  themeClassName?: string; // para customizar tema via classe CSS
}

export const TabelaBase: React.FC<TabelaBaseProps> = ({
  value,
  columns,
  dataKey = 'id',
  header,
  rows = 25,
  paginator = true,
  exportCSV = false,
  scrollable = false,
  scrollHeight = '400px',
  frozenWidth = '200px',
  themeClassName = ''
}) => {
  const dt = useRef<DataTable<any>>(null);

  const exportarCSV = () => {
    dt.current?.exportCSV();
  };

  //<div className={`custom-datatable-wrapper ${themeClassName}`}>
  return (
    <div>
      {exportCSV && <Button label="Exportar CSV" icon="pi pi-upload" className="p-button-sm p-mb-2" onClick={exportarCSV} />}

      <Box sx={{ flex: 1, minHeight: 0 }}>
        <DataTable
          ref={dt}
          value={value}
          paginator={paginator}
          rows={rows}
          rowsPerPageOptions={[10, 25, 50]}
          showGridlines
          size="small"
          dataKey={dataKey}
          header={header}
          className="custom-datatable"
          scrollable={scrollable}
          scrollHeight={scrollable ? scrollHeight || 'flex' : undefined}
          columnResizeMode="expand"
          resizableColumns
          responsiveLayout="scroll"
        >
          {columns.map((col, idx) => (
            <Column
              key={idx}
              field={col.field}
              header={col.header}
              body={col.body}
              sortable={col.sortable}
              filter={col.filter}
              filterPlaceholder={col.filterPlaceholder}
              frozen={col.frozen}
              style={{ ...(col.style || {}) }}
            />
          ))}
        </DataTable>
      </Box>
    </div>
  );
};
